<template>
  <div class="main-vision">
    <h2>主视觉</h2>
  </div>
</template>

<script>
  export default {
    name: 'MainVision'
  };
</script>

<style scoped lang="less">
  .main-vision {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 80vw;
    background-color: silver;
  }
</style>
